import React, { useState, lazy, Suspense } from 'react';

import Loader from './components/Loader';
import NavigationBar from './components/Navbar';
import Hero from './components/Hero';
import Info from './components/Info';

// Lazy-loaded components
const Gallery = lazy(() => import('./components/Gallery'));
const Machines = lazy(() => import('./components/Machines'));
const Projects = lazy(() => import('./components/Projects'));
const References = lazy(() => import('./components/References'));
const Contact = lazy(() => import('./components/Contact'));
const Footer = lazy(() => import('./components/Footer'));

function App() {
  const [loading, setLoading] = useState(true);

  const handleLoaderFinish = () => {
    setLoading(false);
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      const yOffset = -100;
      const y =
        section.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <>
      {/* ✅ Loader overlay olarak çalışır */}
      {loading && <Loader onFinish={handleLoaderFinish} />}

      {/* ✅ Site HER ZAMAN render edilir */}
      <NavigationBar />

      <div id="hero">
        <Hero
          onInfoClick={() => scrollToSection('info')}
          onContactClick={() => scrollToSection('contact')}
        />
      </div>

      <div id="info">
        <Info />
      </div>

      <Suspense fallback={null}>
        <div id="gallery"><Gallery /></div>
        <div id="machines"><Machines /></div>
        <div id="projects"><Projects /></div>
        <div id="references"><References /></div>
        <div id="contact"><Contact /></div>
        <Footer />
      </Suspense>
    </>
  );
}

export default App;
